<template>
    <div class="one-to-one__section">

        <h2 class="one-to-one__section-title">{{ $t("leader") }}</h2>

        <h3>
            <template v-if="leader === 'partner'">
                {{ $t('is-the-most-leader', {x: capitalize(partner.match)}) }}
            </template>
            <template v-else-if="leader === 'user'">
                {{ $t('is-the-most-leader', {x: capitalize(user.name)}) }}
            </template>
            <template v-else>
                {{ $t('are-the-same-leader') }}
            </template>
        </h3>

        <div
            class="leader"
            :class="`leader--${leader}`">

            <img
                class="leader-marker"
                src="@/assets/images/artworks/ligthbulb.svg"
                alt="">


            <div
                v-if="partner"
                id="fluid-filler-wrapper-leader"
                class="fluid-filler-wrapper">
                <div class="fluid-filler">

                    <svg
                        :alt="`${capitalize(partner.name)} (${$t(partnerGender)})`"
                        class="fluid-filler__svg fluid-filler__svg--purple"
                        xmlns="http://www.w3.org/2000/svg"
                        width="118"
                        height="210"
                        viewBox="0 0 118 210"
                        :style="`background-position: ${partnerFillerX}px ${partnerFillerY}px;`">
                        <mask
                            id="mask-woman"
                            fill="black">
                            <rect
                                fill="white"
                                width="120"
                                height="210"/>
                            <image
                                x="0"
                                y="0"
                                width="118"
                                height="210"
                                :href="artworkFilledPartnerUrl" />
                        </mask>

                        <rect
                            fill="#230854"
                            width="120"
                            height="210"
                            mask="url(#mask-woman)" />
                        <image
                            x="0"
                            y="0"
                            width="119"
                            height="210"
                            :href="artworkBorderPartnerUrl" />
                    </svg>

                    <p class="fluid-filler__score">{{ Math.round(partner.pointsperc) }}%</p>
                </div>


                <div
                    v-if="user"
                    class="fluid-filler">
                    <svg
                        :alt="`${$t('yourself')} (${$t(userGender)})`"
                        class="fluid-filler__svg fluid-filler__svg--purple"
                        xmlns="http://www.w3.org/2000/svg"
                        width="118"
                        height="210"
                        viewBox="0 0 118 210"
                        :style="`background-position: ${userFillerX}px ${userFillerY}px;`">
                        <mask
                            id="mask-man"
                            fill="black">
                            <rect
                                fill="white"
                                width="120"
                                height="210"/>
                            <image
                                x="0"
                                y="0"
                                width="118"
                                height="210"
                                :href="artworkFilledUserUrl" />
                        </mask>

                        <rect
                            fill="#230854"
                            width="120"
                            height="210"
                            mask="url(#mask-man)" />
                        <image
                            x="0"
                            y="0"
                            width="118"
                            height="210"
                            :href="artworkBorderUserUrl" />
                    </svg>
                    <p class="fluid-filler__score">{{ Math.round(user.pointsperc) }}%</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Vue from "vue";

export default {
    name: "LeaderSection",
    props: {
        leaderData: {
            type: Array,
            required: true
        },
    },
    data () {
        return {
            partnerFillerX: 0,
            partnerFillerY: 210,
            userFillerX: 0,
            userFillerY: 210,
        };
    },
    computed: {
        leader() {
            if (this.partner && this.user) {
                if (this.partner.pointsperc > this.user.pointsperc ) {
                    return "partner";
                } else if (this.partner.pointsperc < this.user.pointsperc  ) {
                    return "user";
                } else {
                    return "no-leader";
                }
            }
        },
        partner() {
            return this.leaderData.find((item) => {
                return item.same_id_person !== item.id_person;
            });
        },
        user() {
            return this.leaderData.find((item) => {
                return item.same_id_person === item.id_person;
            });
        },
        partnerGender() {
            if (this.partner) {
                if (this.partner.match_gender === "M") {
                    return "man";
                } else {
                    return "woman";
                }
            }
        },
        userGender() {
            if (this.user) {
                if (this.user.match_gender === "M") {
                    return "man";
                } else {
                    return "woman";
                }
            }
        },
        artworkFilledPartnerUrl() {
            if (this.partnerGender) {
                return require("@/assets/images/artworks/who-i-am/gender/" + this.partnerGender + "-filled-purple.svg");
            }
        },
        artworkBorderPartnerUrl() {
            if (this.partnerGender) {
                return require("@/assets/images/artworks/who-i-am/gender/" + this.partnerGender + "-border-purple.svg");
            }
        },
        artworkFilledUserUrl() {
            if (this.userGender) {
                return require("@/assets/images/artworks/who-i-am/gender/" + this.userGender + "-filled-purple.svg");
            }
        },
        artworkBorderUserUrl() {
            if (this.userGender) {
                return require("@/assets/images/artworks/who-i-am/gender/" + this.userGender + "-border-purple.svg");
            }
        }
    },
    mounted: function() {
        Vue.nextTick(() => {
            // Check if element is visible using IntersectionObserver
            // Should probably be polyfilled (https://caniuse.com/#search=IntersectionObserver)
            if ("IntersectionObserver" in window) {
                let lazyBackgroundObserver = new IntersectionObserver((entries, observer) => {
                    const entry = entries[0];

                    if (entry.isIntersecting) {
                        this.launchFill();
                    }
                }, {
                    threshold: 0.05,
                });

                // Increase POLL INTERVAL for polyfill
                // Fix issue on IOS Safari with intersection Observer not working only looking for dom-change and scroll
                // https://github.com/w3c/IntersectionObserver/tree/master/polyfill#configuring-the-polyfill
                lazyBackgroundObserver.POLL_INTERVAL = 100;

                const fluidFillerWrapper = document.getElementById("fluid-filler-wrapper-leader");

                lazyBackgroundObserver.observe(fluidFillerWrapper);
            } else {
                this.launchFill();
            }
        });
    },
    methods: {
        launchFill() {
            if (this.partner && this.user) {
                this.partnerFillerX = 708;
                this.partnerFillerY = 210 - (2.1 * this.partner.pointsperc);

                this.userFillerX = 708;
                this.userFillerY = 210 - (2.1 * this.user.pointsperc);
            }
        }
    }
};

</script>